interface QueryConnection<T> {
  edges?: { node: T }[];
}

export const getNodes = <T>(data?: QueryConnection<T>) => {
  return data && data.edges && data.edges.map(({ node }) => node);
};
